<template>
  <div class="custom-dialog" v-if="visible">
    <div class="model"></div>
    <div class="content">
      <div class="title">{{ conf.title }}</div>
      <div class="context">{{ conf.text }}</div>
      <div class="footer">
        <div class="button confirm" @click="confirm()">
          <Google v-if="conf.type === 'google'" @login="confirm"></Google>
          <div class="txt" :class="{ google: conf.type === 'google' }">{{ conf.confirmTxt }}</div>
        </div>
        <div class="button cancel" v-if="conf.cancelTxt" @click="visible = false">{{ conf.cancelTxt }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Google from './google.vue'
export default {
  name: 'Dialog',
  components: { Google },
  data () {
    return {
      conf: {
        type: 'google',
        googleCb: () => {},
        title: '',
        text: '',
        confirmTxt: '',
        cancelTxt: ''
      },
      visible: false,

      cb: null
    }
  },
  methods: {
    open (data, cb) {
      this.conf = { ...data }
      this.cb = cb
      this.visible = true
    },
    close () {
      this.visible = false
    },
    confirm (data) {
      this.cb && this.cb(data)
      this.visible = false
    }
  }
}
</script>

<style lang='less' scoped >
.custom-dialog {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  .model {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.1);
  }
  .content {
    width: 300px;
    min-height: 180px;
    max-height: 350px;
    background: #FFFFFF;
    border: 1px solid #000000;
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 15px;
  }
  .title {
    font-size: 16px;
    font-weight: 500;
    color: #111111;
    line-height: 1;
    text-align: center;
  }
  .context {
    font-size: 14px;
    font-weight: 500;
    color: #111111;
    line-height: 18px;
    margin: 10px 0;
    flex: 1;
    display: flex;
    align-items: center;
    text-align: center;
  }
  .footer {
    text-align: center;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .button {
    flex: 1;
    height: 28px;
    border-radius: 4px;
    border: 1px solid rgba(255, 90, 0, 1);
    font-size: 14px;
    font-weight: 400;
    line-height: 28px;
    cursor: pointer;
    position: relative;
    & + .button {
      margin-left: 30px;
    }
    &:active {
      filter: none;
    }
    &.confirm {
      color: #FE6918;
      background-color: #ffffff;
      overflow: hidden;
      .txt {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        pointer-events: none;
        background: #ffffff;
      }
    }
    &.cancel {
      color: #ffffff;
      background-color: #FE6918;
    }
  }
}
</style>
